/* template */
<template><div :style="[,(style)] | transRpxStyle" class="packet"><div class="title">{{ title }}</div><div :class='("info "+(numberDigit))' v-if="(couponInfo)"><span class="tip" v-if="(couponTip)">{{couponTip}}</span><span class="integer">{{valueObj.integer}}</span><span class="point" v-if="(valueObj.point)">{{valueObj.point}}</span><span class="decimal">{{valueObj.decimal}}</span><span class="unit">{{couponInfo.max_benefit_capacity.unit}}</span></div><div class="btn-wrapper"><mpx-view @tap="click" class="btn" v-if="(!isSupportWxTag)">{{ btnText }}</mpx-view><launch-app-btn :jumpTargetScheme="(jumpTargetScheme)" :btnText="(btnText)" @launchApp="launchApp" v-else/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m737628c2"}'>
  // 0123456789
  @font-face {
    font-family: DIN-Black-self;
    src: url(https://ut-static.udache.com/webx/ut/IaTeiNIYsw6lOMfe0Q9Lm.ttf);
  }
  .packet
    box-sizing: border-box;
    width 735rpx
    height 744rpx
    overflow hidden
    position relative
    padding 46rpx 0 0 0
    .title
      text-align center
      font-size: 40rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height 1
    .info
      padding-left: 48rpx
      // margin-top 10rpx
      font-size: 350rpx;
      font-family: DIN-Black, DIN-Black-self;
      font-weight: 900;
      color: #FFFFFF;
      text-shadow: 0 5rpx 0 #E10F00;
      display flex
      justify-content: center;
      align-items: flex-end;
      line-height: 1;
      letter-spacing -10rpx
      position relative
      &.digit-3
        margin-top 58rpx
        font-size 240rpx
        padding-left 32rpx
        .point
          margin-left 0
          margin-right -8rpx
        .unit
          font-size: 60rpx;
        .tip
          top: -56rpx;
      &.digit-2
        margin-top 28rpx
        font-size 300rpx
        .tip
          top: -4px;
        .unit
          font-size: 72rpx;
      .tip
        position absolute
        top 52rpx
        left 124rpx
        font-size: 28rpx;
        line-height: 32rpx;
        font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: 0px 1px 0px rgba(212, 110, 70, 0.83);
        letter-spacing 0
        width 53rpx
        box-sizing: border-box;
        padding 14rpx 0 14rpx 10rpx
        align-self: flex-start;
        border: 3rpx solid rgba(255,255,255,1);
        border-radius: 38rpx;
    .unit
      font-size: 84rpx;
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      color: #FFFFFF;
      position relative
      left 16rpx
      top -24rpx
    .point
      margin-left -6rpx
      margin-right -16rpx
    .btn-wrapper, .limit
      position absolute
      left 50%
      transform translate(-50%)
    .btn-wrapper
      background-image: linear-gradient(180deg, #FFFEEF 0%, #FAE5A7 100%);
      box-shadow: 0px 10rpx 19rpx 0px rgba(169,6,6,0.48);
      border-radius: 59rpx;
      width 472rpx
      height 118rpx
      line-height 124rpx
      bottom 64rpx
      font-size: 51rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #E34F49;
      text-align center
      overflow hidden
      .btn
        // background-image: linear-gradient(180deg, #FFFEEF 0%, #FAE5A7 100%);
        // box-shadow: 0px 10rpx 19rpx 0px rgba(169,6,6,0.48);
        // border-radius: 59rpx;
        // width 472rpx
        // height 118rpx
        // line-height 124rpx
        // bottom 64rpx
        // font-size: 51rpx;
        // font-family: PingFang SC;
        // font-weight: bold;
        // color: #E34F49;
        // text-align center
    .limit
      bottom 44rpx
      font-size: 24rpx;
      font-family: PingFang SC;
      font-weight: 300;
      color: #962412;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m737628c2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-close.mpx.js?isComponent&outputPath=components%2Fred-packet-close737628c2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-close737628c2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m737628c2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-close737628c2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-price':getComponent(require("../common/coupon-price.mpx?isComponent&outputPath=components%2Fcoupon-price9261a862%2Findex")),'launch-app-btn':getComponent(require("./wx-launch-app-btn.mpx?isComponent&outputPath=components%2Fwx-launch-app-btn7e8b7c06%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
